module.exports = __webpack_public_path__ + "static/media/Braga.c4280d34.jpg";